// preview_ready — does the owner's preview have something to show? A build that succeeded, or a MOCKUP the
// platform built and showed for review before any build (platform-service design_maquette_study.md §1.7).
// Only the OWNER's workspace reads it: a shared app's viewer, and the publish and data controls, still wait
// for a real build — a mockup's data is invented.
export function previewReady(app: { run_succeeded?: boolean; mockup_shown_at?: string }): boolean {
  return app.run_succeeded === true || (typeof app.mockup_shown_at === "string" && app.mockup_shown_at !== "");
}
